import { useTranslations } from "next-intl";
import { NoResultsDiets } from "@/features/diets/components/no-results-diets";

export const RecommendedDietsSection = () => {
  const t = useTranslations("diets");

  return (
    <div className="w-full basis-full">
      <header className="mb-4">
        <h2 className="font-medium text-2xl">
          {t("no_results_recommended_diets")}
        </h2>
      </header>
      <NoResultsDiets />
    </div>
  );
};
